import httpClient from "@/store/httpClient";

const METRICS_API_URL = "/metrics/heartbeat";

export default {
    namespaced: true,
    state: {
        metrics: undefined,
        filterValues: {
            communes: [],
            roles: [],
        }
    },
    mutations: {
        SET_METRICS(state, metrics) {
            state.metrics = metrics;
        },
        SET_FILTER_VALUES(state, filterValues) {
            state.filterValues.communes = filterValues.communes;
            state.filterValues.roles = filterValues.roles;
        }
    },
    actions:  {
        async fetchFilterValues({ commit }) {
            const response = await httpClient.get(`/metrics/filter-values   `);
            commit("SET_FILTER_VALUES", response.data);
        },
        async fetchMetrics({ commit }, { start, end, selectedCommunes, selectedRoles }) {
            const response = await httpClient.get(`/metrics/analytics?start=${start}&end=${end}&communes=${selectedCommunes}&roles=${selectedRoles}`);
            commit('SET_METRICS', response.data);
        },
        async postHeartbeat(_, { name, parent, type, data }) {
            try {
                if (process.env.NODE_ENV !== "production") {
                 console.log('Posting heartbeat metric', { name, parent, type, data });
                }

                await httpClient.post(METRICS_API_URL, {
                    name,
                    parent,
                    type,
                    data
                });
            } catch (e) {
                // silently fail
                if (process.env.NODE_ENV !== "production") {
                    console.error("Failed to post heartbeat metric", e);
                }
            }
        }
    }
}